import { selectCurrentProjectVenue } from '@/domain/project-venue/project-venue.selectors';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

import { CalculateVenueCo2 } from '../entities/calculate-venue-co2.entity';
import { dispatchTwiceGetImpactVenueCo2 } from './utils/dispatch-twice-get-impact-venue-co2';

type Params = {
  projectId: number;
};

type Result = {
  co2: CalculateVenueCo2;
};

/**
 * In the venue case, runCalulate include structure questions only, not dates and months questions
 */
export const runImpactCalculateVenueCo2ForProject = createAppAsyncThunk(
  'impactCalculateVenue/runImpactCalculateVenueCo2ForProject',
  async (
    params: Params,
    {
      extra: { impactCalculateVenueGateway, snackbarGateway },
      dispatch,
      getState,
    },
  ): Promise<Result> => {
    try {
      const modelEnvVersion = 'ENV_SEASON';
      const calculateCo2 =
        await impactCalculateVenueGateway.runImpactCalculateVenueCo2ForProject(
          params.projectId,
          modelEnvVersion,
        );
      const currentProject = selectCurrentProjectVenue(getState());
      if (currentProject) {
        dispatchTwiceGetImpactVenueCo2(dispatch, currentProject.id);
      }
      // this action returns a calculateCo2 object with less data than the one from getImpactCalculateVenueCo2ForProject
      // the redux-slice don't use this return
      return { co2: calculateCo2 };
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('GetImpactCalculate.Message.error'));
}
